module.exports = __webpack_public_path__ + "img/quick_04.4a96107e.png";